import { Box, Typography } from '@mui/material';
import OneImage1 from 'assets/OneImage1.webp';
import OneImage2 from 'assets/OneImage2.webp';
import { allowedFilesMap } from './DataSetForm';

export default function OneDescription() {
  return (
    <Box>
      <Typography variant='h6'>"One" Chunking Method Description</Typography>
      <Typography marginTop={1}>
        Supported file formats are {allowedFilesMap.one.join(', ')} . For a document, it will be treated as an entire
        chunk, no split at all.
      </Typography>
      <Typography marginY={3}>
        If you want to summarize something that needs all the context of an article and the selected LLM's context
        length covers the document length, you can try this method.
      </Typography>

      <Typography fontWeight='500' marginTop={3}>
        "One" Examples
      </Typography>
      <Typography marginBottom={3}>The following screenshots are presented to facilitate understanding.</Typography>
      <Box display='flex' overflow='auto' justifyContent='center' gap={1}>
        <img src={OneImage1} alt='law' width={320} />
        <img src={OneImage2} alt='law' width={320} />
      </Box>
    </Box>
  );
}
